import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import * as Api from "@/app/interaction/api";
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import { FlipcardItem, FlipcardState, FlipcardContent } from './flipcard-interfaces';
import { createInteractionComponent } from '@/app/interaction/ui'

@injectable()
export class IncludeFlipcardHandler implements Api.IncludeComponentsHandlerInterface {
  
  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.flipcard.component', $parsedContent);
    if (elements === null) {
      return [];
    }

    let components = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const title: string|null = $('.flipcard__title', $element).text() || null;
    const instruction: string|null = $('.flipcard__instruction', $element).html() || null;
    const items: FlipcardItem[] = this.getItems($('.flipcard__item', $element));

    const interactionComponent = createInteractionComponent<FlipcardContent, FlipcardState>(id, 'flipcard', {
      title,
      instruction
    }, {
      items
    })
    interactionComponent.$mount();


    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }

  private getItems($items: any): FlipcardItem[] {
    let items: FlipcardItem[] = [];
    $items.each((i: number, item: any) => {
      const $item = $(item);
      items = [...items, {
        label: $('.flipcard__label', $item).html(),
        content: $('.flipcard__content', $item).html()
      }];
    });

    return items;
  }
}
